import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { lastValueFrom } from 'rxjs';
import { entAnimations } from 'src/app/animations';
import { GraphService } from 'src/app/services/graph/graph.service';
import { Error } from 'src/app/models/error.model';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { SharemailboxDeleteConfirmComponent } from 'src/app/main/exchange/sharemailbox/sharemailbox-delete-confirm/sharemailbox-delete-confirm.component';
import { TeamGraph } from 'src/app/models/team-graph.model';

@Component({
  selector: 'app-restore-team-dialog',
  encapsulation: ViewEncapsulation.None,
  animations: entAnimations,
  templateUrl: './restore-team-dialog.component.html',
  styleUrl: './restore-team-dialog.component.scss',
  standalone: false,
})
export class RestoreTeamDialogComponent {
  spinner = {
    color: 'primary',
    mode: 'indeterminate' as ProgressSpinnerMode,
    value: 50,
    diameter: 50,
  };
  error: Error = { error: { message: '', code: '' } };
  isError = false;
  isSuccess = false;
  isLoading = false;
  constructor(
    private _graphService: GraphService,
    @Inject(MAT_DIALOG_DATA) public data: { team: TeamGraph },
    public matDialogRef: MatDialogRef<SharemailboxDeleteConfirmComponent>
  ) {}

  async restoreTeam() {
    try {
      this.isLoading = true;
      await lastValueFrom(
        this._graphService.restoreDeletedTeam(this.data.team.id)
      ).then(async () => {
        await this.sleep(2000);
        this.isLoading = false;
        this.isSuccess = true;
        this.matDialogRef.close(true);
      });
    } catch (error) {
      let customError: Error = { error: undefined };
      if (error.statusText == 'Unknown Error') {
        customError = { error: { message: 'Unknown Error', code: 'ERR2' } };
      } else {
        if (error.error.errors) {
          customError = { error: { message: 'Unknown Error', code: 'ERR2' } };
        } else if (error.error) {
          customError = error.error;
        }
        if (customError.error === undefined) {
          customError = { error: { message: 'Unknown Error', code: 'ERR2' } };
        }
      }

      this.isError = true;
      this.isSuccess = false;
      this.error = customError;
      this.isLoading = false;
    } finally {
      /* empty */
    }
  }

  async sleep(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}
